<template>
  <div 
    :id="id"
    class="modal fade"
    tabindex="-1"
    :aria-labelledby="`${id}-title`"
    aria-hidden="true"
  >
    <div
      class="modal-dialog"
      :class="sizeClass"
    >
      <div 
        class="modal-content"
      >
        <div 
          class="d-flex align-items-center justify-content-between modal-header"
        >
          <slot 
            name="header"
          >
            <h5 
              :id="`${id}-title`"
              class="modal-title"
            >
              {{ title }}
            </h5>
          </slot>

          <material-icon
              icon="close"
              class="close"
              @click="hide"
            />
        </div>

        <div class="modal-body">
          <slot />
        </div>

        <div class="modal-footer">
          <slot 
            name="footer"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap';

import MaterialIcon from '@/components/UI/MaterialIcon.vue';

const SMALL  = 'sm';
const LARGE  = 'lg';
const XLARGE = 'xl';

export default {
  components: {
    MaterialIcon
  },

  props: { 
    id: { type: String, required: true },
    title: { type: String, required: true },
    size: { 
      type: String, 
      default: null,
      validator(value) {
        return [
          null, 
          SMALL, 
          LARGE,
          XLARGE
        ].includes(value);
      }
    }
  },

  emits: [
    'showing',
    'fully-shown',
    'hiding',
    'fully-hidden'
  ],

  data() {
    return {
      element: null
    };
  },

  computed: {
    sizeClass() {
      const prefix = 'modal-';

      switch(this.size) {
        case SMALL:
          return `${prefix}sm`;
        case LARGE:
          return `${prefix}lg`;
        case XLARGE:
          return `${prefix}xl`;
        default:
          return '';
      }
    }
  },

  mounted() {
    this.validateSizeClass();
    this.element = new Modal(this.$el);

    this.setupBootstrapModalHooks();
  },

  methods: {
    validateSizeClass() {
      switch(this.size) {
        case null:
          return;
        case SMALL:
          return;
        case LARGE:
          return;
        case XLARGE:
          return;
      }

      let warning = 'Invalid size passed to modal. Valid values are: ';
      warning += `null, '${SMALL}', '${LARGE}' and '${XLARGE}'.`;
      console.warn(warning);
    },

    setupBootstrapModalHooks() {
      this.$el.addEventListener('show.bs.modal',   () => this.$emit('showing'));
      this.$el.addEventListener('shown.bs.modal',  () => this.$emit('fully-shown'));
      this.$el.addEventListener('hide.bs.modal',   () => this.$emit('hiding'));
      this.$el.addEventListener('hidden.bs.modal', () => this.$emit('fully-hidden'));
    },

    show() {
      this.element.show();
    },

    hide() {
      this.element.hide();
    }
  }
}
</script>

<style lang="scss">
.modal-header .close {
  cursor: pointer;
}
</style>